/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { CreateEnumerationEvaluationParameterDtoTrackItFilter } from './CreateEnumerationEvaluationParameterDtoTrackItFilter';
import {
    CreateEnumerationEvaluationParameterDtoTrackItFilterFromJSON,
    CreateEnumerationEvaluationParameterDtoTrackItFilterFromJSONTyped,
    CreateEnumerationEvaluationParameterDtoTrackItFilterToJSON,
} from './CreateEnumerationEvaluationParameterDtoTrackItFilter';
import type { EnumerationEvaluationOptionDto } from './EnumerationEvaluationOptionDto';
import {
    EnumerationEvaluationOptionDtoFromJSON,
    EnumerationEvaluationOptionDtoFromJSONTyped,
    EnumerationEvaluationOptionDtoToJSON,
} from './EnumerationEvaluationOptionDto';

/**
 * 
 * @export
 * @interface EnumerationEvaluationParameterDto
 */
export interface EnumerationEvaluationParameterDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationEvaluationParameterDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationEvaluationParameterDto
     */
    allowRepetition?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationEvaluationParameterDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    instruction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    evaluationScopeName?: string | null;
    /**
     * 
     * @type {Array<EnumerationEvaluationOptionDto>}
     * @memberof EnumerationEvaluationParameterDto
     */
    options?: Array<EnumerationEvaluationOptionDto> | null;
    /**
     * 
     * @type {CreateEnumerationEvaluationParameterDtoTrackItFilter}
     * @memberof EnumerationEvaluationParameterDto
     */
    trackItFilter?: CreateEnumerationEvaluationParameterDtoTrackItFilter | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationParameterDto
     */
    $type?: EnumerationEvaluationParameterDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationEvaluationParameterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersEnumerationEvaluationParameterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.EnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationEvaluationParameterDtoTypeEnum = typeof EnumerationEvaluationParameterDtoTypeEnum[keyof typeof EnumerationEvaluationParameterDtoTypeEnum];



/**
 * Check if a given object implements the EnumerationEvaluationParameterDto interface.
 */
export function instanceOfEnumerationEvaluationParameterDto(value?: unknown): value is EnumerationEvaluationParameterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationEvaluationParameterDtoTypeEnum)[0];
}

export function EnumerationEvaluationParameterDtoFromJSON(json: any): EnumerationEvaluationParameterDto {
    return EnumerationEvaluationParameterDtoFromJSONTyped(json, false);
}

export function EnumerationEvaluationParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationEvaluationParameterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'allowRepetition': json['allowRepetition'] == null ? undefined : json['allowRepetition'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'instruction': json['instruction'] == null ? undefined : json['instruction'],
        'evaluationScopeName': json['evaluationScopeName'] == null ? undefined : json['evaluationScopeName'],
        'options': json['options'] == null ? undefined : ((json['options'] as Array<any>).map(EnumerationEvaluationOptionDtoFromJSON)),
        'trackItFilter': json['trackItFilter'] == null ? undefined : CreateEnumerationEvaluationParameterDtoTrackItFilterFromJSON(json['trackItFilter']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EnumerationEvaluationParameterDtoToJSON(value?: EnumerationEvaluationParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'dataTypeId': value['dataTypeId'],
        'isEnabled': value['isEnabled'],
        'iuid': value['iuid'],
        'allowRepetition': value['allowRepetition'],
        'origin': EntityOriginToJSON(value['origin']),
        'instruction': value['instruction'],
        'evaluationScopeName': value['evaluationScopeName'],
        'options': value['options'] == null ? undefined : ((value['options'] as Array<any>).map(EnumerationEvaluationOptionDtoToJSON)),
        'trackItFilter': CreateEnumerationEvaluationParameterDtoTrackItFilterToJSON(value['trackItFilter']),
        '$type': value['$type'],
    });
}

